import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Steps } from "primereact/steps";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import DashboardKycSideBar from "./dashboardSidebar";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import configureStore from "../../redux/store";
import { useSelector } from "react-redux";
import QRCode from "react-qr-code";
import ApiBaseURLProps from "../other/apiBaseURL";
import CustomQRCode from "../lookup/customQRCode";
import RequestForModificationView from "../lookup/kycView";
import VerificationService from "../service/VerificationService";
import { Skeleton } from 'primereact/skeleton';
import ApiService from "../service/apiService";
import { Calendar } from 'primereact/calendar';
import { Dialog } from "primereact/dialog";
import { formatDate } from "../other/adBsDatePicker";
import { RadioButton } from "primereact/radiobutton";
import { compareDateMonthDay, convertTimeToDate, formatAMPM, getTotalDaysInMonth } from "../../helper/helper";
import { confirmDialog } from "primereact/confirmdialog";
import postApiService from "../service/postApiService";
import { useToast } from "../other/Toast";
import Biometrics from "../kyc/Biometrics";
import { useTranslation } from "react-i18next";
import NepaliDatePicker2 from "../other/nepaliDatePicker";
import { Message } from 'primereact/message';

const items = [
    {
        status: "IC",
        label: "Pending for Modification",
        message: `Your application is currently pending. 
    Please visit your KYC registration agent to complete the process. 
    The KYC registration agent will take your biometric information and signature.`,
        disabled: true,
    },
    {
        status: "P",
        label: "Pending",
    },
    {
        status: "I",
        label: "Initiated",
    },
    {
        status: "PR",
        label: "Processing",
    },
    {
        status: "R",
        label: "Rejected",
        disabled: true,
        message: "Your KYC application is rejected",
    },
    {
        status: "V",
        label: "Verified",
        message: "Your KYC application is verified",
    },
];

const MobileDashboard = () => {

    const toast = useToast();
    const history = useHistory();

    const [videoKycEvent, setVideoKycEvent] = useState();
    const [videoKycSlot, setVideoKycSlot] = useState();
    const [viewKycInfoModal, setViewKycInfoModal] = useState();
    const [viewBiometrics, setViewBiometrics] = useState();


    const onSlotBook = async () => {
        fetchFirst();
        setViewKycInfoModal(true);
    }

    const fetchFirst = async () => {
        await ApiService.getVideoKycEvent().then((response) => {
            if (!response.data || !response.data.videoKycScheduleDto) return;
            setVideoKycEvent({ ...response.data.videoKycScheduleDto, status: response.data.status });
            setVideoKycSlot({ ...(response.data.videoKycScheduleDto.videoKycSlotList.find(s => s.id === response.data.videoKycSlotId) || {}), sessionDate: response.data.videoKycScheduleDto.sessionDate });

        }).catch(e => {
            setVideoKycEvent({ status: 'B' })
        });
    }

    useEffect(() => {
        fetchFirst();
    }, []);

    const { firstName, middleName, lastName } =
        useSelector((state) => state.personalDetails) || {};
    const { tempKycId, permKycId, status, customerId, formType } =
        useSelector((state) => state.routerData) || {};
    const {
        emailId,
        mobileNo,
        countryDesc,
        stateDesc,
        districtDesc,
        municipalityDesc,
        ward,
        tole,
    } = useSelector((state) => state.addressDetails) || {};
    const personDocumentDetailList = useSelector(
        (state) => state.documentDetails.documentList
    );

    const photo = personDocumentDetailList.find((d) => d.documentTypeId === "PH");

    const photoUrl =
        photo && ApiBaseURLProps.apiBaseURL + "/file/" + photo.fileId;

    let activeIndex = -1;
    let message = "";
    let dashStepList = items;
    if (status) {
        if (status === "R") {
            items[items.length - 2].disabled = false;
            items[items.length - 1].disabled = true;
        }

        if (!permKycId || status === "IC") items[0].disabled = false;

        dashStepList = items.filter((it) => !it.disabled);

        activeIndex = dashStepList.findIndex((i) => i.status === status);

        if (activeIndex != -1) {
            message = dashStepList[activeIndex].message;
        }
    }

    useEffect(() => {
        if (customerId)
            VerificationService.detail(customerId).then((response) => {
                setData(response.data);
            });

        if (customerId && !status) {
            if (formType === "C") history.push("/kyc/company");
            else history.push("/kyc/person");
        }
    }, [customerId]);

    const [data, setData] = useState([]);

    const enableEdit = customerId && status !== "IC" && status !== "P" && status !== "I" && status !== "PR";

    const qrData = useSelector(state => {
        const gfObj = state.familyDetails && state.familyDetails.relativeList && state.familyDetails.relativeList.find(r => r.relativeTypeId === 'GF');
        const fObj = state.familyDetails && state.familyDetails.relativeList && state.familyDetails.relativeList.find(r => r.relativeTypeId === 'F');
        const czObj = state.documentDetails && state.documentDetails.documentList && state.documentDetails.documentList.find(r => r.documentTypeId === 'CZ');
        const qrData = {
            grandFatherName: gfObj && (gfObj.firstName + ' ' + (gfObj.middleName ? gfObj.middleName + ' ' : '') + gfObj.lastName),
            fatherName: fObj && (fObj.firstName + ' ' + (fObj.middleName ? fObj.middleName + ' ' : '') + fObj.lastName),
            citizenshipNo: czObj && czObj.docId,
            issuedDate: czObj && czObj.issuedDate,
            czDistrict: czObj && czObj.issuedFrom
        };

        return qrData;
    });

    qrData.name = firstName + ' ' + (middleName ? middleName + ' ' : '') + lastName;
    qrData.permKycId = permKycId;

    const { blockForm } = useSelector((state) => state.routerData);

    const [qrInfo, setQrInfo] = useState({});
    const [viewVideoSessionModal, setViewVideoSessionModal] = useState(false);
    useEffect(() => {
        if (permKycId) {
            console.log("test qrcode", permKycId)
            ApiService.getQRInfo(permKycId).then(response => {
                setQrInfo(response.data);
            })
        }
    }, [permKycId])

    return (
        <div className="p-grid">

            <VideoKycInfo videoKycSlot={videoKycSlot} toast={toast} viewKycInfoModal={true} setViewKycInfoModal={setViewKycInfoModal} setViewBiometrics={setViewBiometrics} />

        </div>
    );
};

const VideoKycSlotDialog = ({ toast, viewVideoSessionModal, setVideoSessionModal, onSlotBook }) => {
    const { t, i18n } = useTranslation();

    const [videoKycScheduleId, setVideoKycScheduleId] = useState();
    const [slotList, setSlotList] = useState([]);
    const [slot, setSlot] = useState();
    const [tempDate, setTempDates] = useState([]);
    const [dates, setDates] = useState();
    const [invalidDates, setInvalidDates] = useState([]);


    const getSlots = async (date) => {
        console.log("inside getSlots", date);
        // let foundDate = dates.find(d => {
        //   return new Date(d) == new Date(date);
        // })
        // if (foundDate) {
        //get slots

        let foundSchedule = tempDate.find(td => compareDateMonthDay(td.sessionDate, date));
        if (!foundSchedule) return;
        let tempSlot = await ApiService.getScheduleSlots(foundSchedule.videoKycScheduleId);
        if (!tempSlot || !tempSlot.data) return;
        setVideoKycScheduleId(foundSchedule.videoKycScheduleId);

        let sortedSlotTime = tempSlot.data.map(t1 => {
            t1.startTime = convertTimeToDate(t1.startTime);
            t1.endTime = convertTimeToDate(t1.endTime);
            return t1;
        }).sort(function (a, b) {
            return (a.startTime < b.startTime) ? -1 : ((a.startTime > b.startTime) ? 1 : 0);
        });

        setSlotList(sortedSlotTime);

        // }
    }

    const fetchFirst = async () => {
        //get schedules
        let tempDates = [];

        ApiService.getSchedulesByDp().then(response => {
            let tempSchedules = response.data;
            if (tempSchedules && tempSchedules.length > 0) {

                tempSchedules.forEach((s) => {
                    tempDates.push(new Date(s.sessionDate));
                });
                // dateChangeFunction(new Date(), tempDates);
                setTempDates(tempSchedules);
                setDates(tempDates);
            }
        });
    }

    const dateChangeFunction = async (date, openDates) => {
        let tempDaysArray = getTotalDaysInMonth((new Date(date).getMonth() + 1), (new Date(date).getFullYear() + 1));
        if (openDates) {
            let newDatesArray = tempDaysArray.map(d => {
                let foundDate = openDates.find(d1 => new Date(d1) === new Date(d));
                if (!foundDate) return d;
            });
            return newDatesArray;
        }
    }
    useEffect(() => {
        fetchFirst();
    }, []);
    const saveSlot = async () => {
        if (!slot) {

            toast.error("Error Message", "Please select available slot.");
            return;
        }
        ApiService.checkCancelledMoreThan5().then(response => {
            console.log(response, "cancelled");
            if (response.data === true) {
                toast.error("User cancel exceeded.");
            } else {

                let formattedTIme = new Date(slot.startTime).getHours() + ':' + new Date(slot.startTime).getMinutes();

                confirmDialog({
                    message: "Are you sure you want to proceed?",
                    header: "Confirmation",
                    icon: "pi pi-exclamation-triangle",
                    accept: () => {
                        postApiService.saveVideoKycEventSlot({
                            videoKycScheduleId: videoKycScheduleId,
                            videoKycSlotId: slot.id
                        }, formattedTIme).then(r => {
                            setVideoSessionModal(false);
                            toast.success("Sucessfully submitted.");
                            onSlotBook();
                            // setTimeout(() => window.location.href = '/kyc/dashboard', 500);
                        }).catch(error => {

                            if (error.response && error.response.status === 500) {
                                toast.error("Error Message", error.response.message);
                            } else
                                toast.error("Error Message", "Failed to submit.");
                        })
                    },
                });
            }
        });
    }


    return (
        <Dialog
            header="Book Video KYC"
            visible={viewVideoSessionModal}
            style={{ height: "550px" }}
            // footer={renderFooter}
            onMaskClick={(e) => {
                console.log('mask click', e.target.className);
                if (e.target.className.includes("mask") && !((slotList && slotList.length > 0)))
                    setVideoSessionModal(false);
            }}
            onHide={() => {
                setSlotList([]);
                setVideoSessionModal(false);
            }}
        >

            {(!slotList || slotList.length <= 0) && viewVideoSessionModal !== 2 &&
                <div id="vkyc-calander">
                    {/* <Calendar
            id="basic"
            value={new Date}
            onChange={(e) => {
              console.log("walla", e.value);
              setDate1(e.value);
            }}
          // onViewDateChange={(e) => {
          //   console.log("walla", new Date(e.value).getMonth());
          // }}
          /> */}
                    {i18n.language !== 'np' && <Calendar
                        // selectionMode="multiple"
                        // minDate={new Date()}
                        value={dates}
                        inline
                        onChange={(e) => {
                            console.log(e.value, "onselect")
                            getSlots(e.value);
                            // getSlots(e.value[e.value.length - 1]);
                            setVideoSessionModal(2);
                        }}

                        dateTemplate={(e) => {
                            let tempDay = null;
                            if (dates) {
                                tempDay = dates.find(d => compareDateMonthDay(new Date(d), new Date(e.year, e.month, e.day)));
                            }

                            return (
                                <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', backgroundColor: tempDay ? "#008080" : '', color: tempDay ? "white" : '' }}>
                                    <span>{e.day}</span>
                                </span>
                            );
                        }}
                    // onViewDateChange={(e) => {
                    //   console.log("walla");
                    // }}
                    // disabledDates={invalidDates}
                    // touchUI
                    />}
                    {i18n.language === 'np' && <div>
                        <NepaliDatePicker2
                            show={true}
                            options={{ closeOnSelect: false }}
                            style={{ display: 'none' }}
                            inputClassName={"p-inputtext display-none p-component"}
                            placeholder={t("dateInBs")}
                            onChange={(value) => {
                                let bsDate = value;
                                let adDate = null;
                                let date;
                                if (viewVideoSessionModal !== 1) {
                                    setVideoSessionModal(1);
                                    return;
                                }
                                try {
                                    date = bsToAd(value);
                                    adDate = formatDate(date);
                                    getSlots(adDate);
                                    setVideoSessionModal(2);
                                } catch (e) { }
                            }}
                        /></div>}
                </div>

            }
            {(slotList && slotList.length > 0) && viewVideoSessionModal === 2 &&
                <div className="p-field p-col-12 p-md-5 stick-right">
                    <label className="p-col-12 p-md-12" htmlFor="gender">
                        Select available time :
                    </label>
                    {
                        slotList.map((tempSlot, i) => {
                            return (
                                <div>
                                    {tempSlot.id &&
                                        <div className="p-field-radiobutton p-col-12 p-md-12 p-ml-2 ">
                                            <RadioButton inputId={tempSlot.id} name="slot" value={tempSlot} onChange={(e) => setSlot(e.value)} checked={slot && (slot.id === tempSlot.id)} />
                                            <label htmlFor={tempSlot.id}>{formatAMPM(new Date(tempSlot.startTime), false, true) + " - " + formatAMPM(new Date(tempSlot.endTime), false, true)}</label>
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }

                    <Button
                        className="p-button-success"
                        label="Submit"
                        iconPos="right"
                        onClick={(e) => {
                            saveSlot();
                        }
                        }
                        style={{ margin: 5, flex: 1 }}
                    />
                </div>
            }
        </Dialog>
    );
}

export const VideoKycInfo = ({ videoKycSlot, toast, viewKycInfoModal, setViewKycInfoModal, setViewBiometrics }) => {
    return (
        <Dialog
            header={videoKycSlot && ((videoKycSlot.sessionDate) + ', ' + (formatAMPM(new Date(convertTimeToDate(videoKycSlot.startTime)), false, true)))}
            visible={viewKycInfoModal}
            // footer={renderFooter}
            onHide={() => {
                setViewKycInfoModal(false);
            }}
        >
            {videoKycSlot && (<div>
                <div>
                    Your video KYC meeting is on {(videoKycSlot.sessionDate) + ' at ' + (formatAMPM(new Date(convertTimeToDate(videoKycSlot.startTime)), false, true))}. Please join 5 minutes before the allocated time with pen and paper(White paper prioritized). Make sure you have required identity document that you uploaded on our website.
                </div>
                <br />
                {compareDateMonthDay(new Date(videoKycSlot.sessionDate), new Date()) && <Button
                    style={{
                        borderRadius: "19px",
                        minWidth: "122px",
                        margin: 5
                    }}
                    onClick={(e) => {
                        window.location.href = "/kyc/video-kyc?mobileView=true"
                    }}
                >
                    <span>
                        <i className="pi pi-phone" />
                        {' '}Join
                    </span>
                </Button>}

                {videoKycSlot && (
                    <Button
                        className="p-button-danger"
                        style={{
                            borderRadius: "19px",
                            minWidth: "122px",
                            margin: 5
                        }}
                        onClick={(e) => {

                            confirmDialog({
                                message: "Are you sure you want to cancel the session booking, you are only allowed to cancel and rebook 5 times!",
                                header: "Confirmation",
                                icon: "pi pi-exclamation-triangle",
                                accept: () => {
                                    postApiService.cancelKycVideoSessionBooking().then(r => {
                                        toast.success("Sucessfully Cancelled.");
                                        setViewKycInfoModal(false);
                                        setTimeout(() => window.location.href = '/kyc/dashboard', 500);
                                    }).catch(error => {
                                        toast.error("Error Message", "Failed to Cancel.");
                                    })
                                },
                            });
                        }}
                    >
                        <span>
                            <i className="pi pi-times" />
                            {' '}Cancel Booking
                        </span>
                    </Button>
                )}
                <Button
                    style={{
                        borderRadius: "19px",
                        minWidth: "122px",
                        margin: 5
                    }}
                    onClick={(e) => {
                        setViewBiometrics(true);
                    }}
                >
                    <span>
                        <i className="pi pi-id-card" />
                        {' '}Biometrics
                    </span>
                </Button>
            </div>)}
        </Dialog >

    )
}


export default MobileDashboard;
